export const columnsCsv = [
  { label: "Date", key: "createdDate" },
  { label: "Name", key: "fullName" },

  { key: "mobile", label: "Mobile" },
  { key: "beneficiaryName", label: "Beneficiary" },
  { key: "country", label: "Country" },
  { key: "type", label: "Type" },
  { label: "Sent(AED) ", key: "sent" },
  { key: "status", label: "Status" },
  { key: "c3REF", label: "C3 Ref" },
  { key: "rakref", label: "RAK Ref" },
];

export const options = [
  { value: "SUCCESSFUL", label: "Success" },
  { value: "PENDING", label: "Pending" },
  { value: "FAILED", label: "Failed" },
  { value: "REVERSED", label: "Reversed" },
  { value: "PENDINGREVERSE", label: "PendingReverse" },
  { value: "FAILEDTOREVERSE", label: "FailedToReverse" },
];
export const options1 = [
  { value: "BANKTRANSFER", label: "Bank Transfer" },
  { value: "CASHPICKUP", label: "Cash Pickup" },
];
export const options2 = [
  { value: "PK", label: "Pakistan" },
  { value: "IN", label: "India" },
  { value: "NP", label: "Nepal" },
  { value: "BD", label: "Bangladesh" },
  { value: "PH", label: "Philippines" },
  { value: "LK", label: "Sri Lanka" },
];
